import styled from 'styled-components/macro';

import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from "@chakra-ui/react";
import {useCancelSubscription} from "../api/payments";
import {useFeedback} from "../store/feedback";

const CancelProSubscription = styled(({className, onClose}) => {

    const {error, feedbackCh} = useFeedback();
    const cancelSubscription = useCancelSubscription(feedbackCh);
    const toast = useToast();

    const handleCancel = async () => {
        try {
            await cancelSubscription();
            toast({
                title: `Your subscription has been cancelled.`,
                status: 'success',
                isClosable: true,
            });
            onClose();
            return;
        } catch {}
        toast({
            title: `Something went wrong.`,
            status: 'error',
            isClosable: true,
        });
    };


    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Are you sure?</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <p>
                        Your support is invaluable in helping us continue to provide a platform.
                    </p>
                    <p style={{marginTop: 8}}>
                        Are you sure you want to cancel your subscription?
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Go back</Button>
                    <Button variant="blue" onClick={handleCancel}>
                        Yes
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
`;

export default CancelProSubscription;
